import PageTitleComponent from '72cms-ui/components/table-elements/PageTitleComponent';
import PublishStatusComponent from '72cms-ui/components/table-elements/PublishStatusComponent';
import PopoverConfigComponent from '72cms-ui/components/table-elements/PopoverConfigComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        name: {
            component: PageTitleComponent,
        },
        // published: {
        //     label: ' ',
        //     component: PublishStatusComponent,
        // }
    },
    filterable: ['content_type'],
    sortable: [],
    toolbar: ['create'],
    pagination: true,
    searchable: true,
    hierarchy: true,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'config',
            primary: true,
            component: PopoverConfigComponent,
            fields: ['show_in_menu', 'show_in_responsive_menu', 'show_in_footer', 'open_in_new_tab'],
        },
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'preview',
            component: 'preview-button',
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.pages.js